<template>
    <p-search-screen
        title="Feature Flags"
        api-destination="featureflags"
        :filters="filters"
        :fields="fields"
        :filterBy="filterBy"
        add-new-button
        edit-key="id"
        @isActiveChanged="updateIsActiveStatus"
    />
</template>

<script>

import axios from 'axios';
import SearchStorage from '@/components/mixins/SearchFilterStorage.js';

export default {
    mixins: [SearchStorage],
    data() {
        return {
            filterName: 'FeatureFlagFilter',
            filters: {
                automatic: "",
                perPage: 100,
                sortBy: 'name',
                sortDesc: true,
                searchBy: 'All'
            },
            filterBy: ['All'],
            fields: [
                {
                    key: 'name',
                    sortable: true
                },
                {
                    key: 'client',
                    sortable: true
                },
                {
                    key: 'description',
                    sortable: true
                },
                {
                    key: 'startDate',
                    sortable: true
                },
                {
                    key: 'isActive',
                    sortable: true
                }
            ]
        };
    },

    created() {
    },

    watch: {},

    methods: {

        getAssignedClass(item) {
            if (item.assigned == 'All') {
                return 'text-success';
            } else if (item.assigned == 'Partial') {
                return 'text-warning';
            } else {
                return 'text-danger';
            }
        },
        updateIsActiveStatus(featureFlag) {
            axios.post('featureflags/setisactive', featureFlag).then(() => {
                var msg = `${featureFlag.name} ${
                    featureFlag.isActive ? 'activated' : 'de-activated'
                } successfully`;
                this.$appSuccess(msg);
            });
        },
    }
};
</script>
